module.exports = __webpack_public_path__ + "static/media/cyttekLogo.d80cc297.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cyttekLogo.png
// module id = 776
// module chunks = 0